export const SET_API_ERROR = 'SET_API_ERROR'
export const CLEAR_API_ERROR = 'CLEAR_API_ERROR'

export const setApiError = ({
  httpMethod,
  route,
  error,
  key,
}: {
  httpMethod: string
  route: string
  error: any
  key: string | number
}) => {
  return {
    type: SET_API_ERROR,
    httpMethod,
    route,
    error,
    key,
  }
}

export const clearAPIError = ({
  httpMethod,
  route,
  key,
}: {
  httpMethod: string
  route: string
  key?: string | number
}) => {
  return {
    type: CLEAR_API_ERROR,
    httpMethod,
    route,
    key,
  }
}
